type MeasuredAudio = {
  byteVerified?: boolean; format?: string; codec?: string; bitrate?: number | null;
  sampleRate?: number | null; channels?: number | null; bitsPerSample?: number | null; bitrateBasis?: string | null;
};

// Classify the observed encoding only. Platform brand tiers and the recording's
// original fidelity cannot be inferred from a codec, bit depth or sample rate.
export function measuredQualityLabel(data?: MeasuredAudio | null): string {
  if (data?.byteVerified !== true) return '未判定';
  const format = String(data.format || '').trim().toLowerCase();
  const rate = data.sampleRate, depth = data.bitsPerSample, bitrate = data.bitrate;
  if (format === 'mp4' && data.codec === 'aac' && [7350,8000,11025,12000,16000,22050,24000,32000,44100,48000,64000,88200,96000].includes(rate!) && [1,2,3,4,5,6,8].includes(data.channels!)) return 'AAC 有损';
  if (format === 'flac' && Number.isInteger(rate) && rate! > 0 && rate! <= 655350 && Number.isInteger(depth) && depth! >= 4 && depth! <= 32) {
    return [16, 24, 32].includes(depth!) ? `${depth}-bit 无损` : '无损';
  }
  if (format === 'mp3' && [8000, 11025, 12000, 16000, 22050, 24000, 32000, 44100, 48000].includes(rate!) && Number.isInteger(bitrate) && bitrate! > 0 && bitrate! <= 448000) {
    const label = bitrate === 128000 ? '标准品质' : bitrate === 320000 ? '高品质有损' : '有损';
    // Standard quality has an exact short label; frame evidence stays in the
    // detailed audio-parameter line. Preserve the other existing tier names.
    return label + (bitrate !== 128000 && data.bitrateBasis === 'mpeg-frame' ? '（按帧）' : '');
  }
  return '未判定';
}
